module.exports = __webpack_public_path__ + "img/5.63b6b94b.png";